import React from "react";
import { Table, Card } from "antd";
import { useGetGrowwHoldingQuery} from "../slices/gowwApiSlices";

const GrowwHoldings = () => {
  const { data, isLoading } = useGetGrowwHoldingQuery();

  const columns = [
    {
      title: "Symbol",
      dataIndex: "trading_symbol",
      key: "symbol",
      width: 150,
    },
    {
      title: "Exchange",
      dataIndex: "exchange",
      key: "exchange",
      width: 100,
    },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      width: 100,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 100,
    },
    {
      title: "Avg Price",
      dataIndex: "average_price",
      key: "average_price",
      width: 120,
    },
    {
      title: "LTP",
      dataIndex: "ltp",
      key: "ltp",
      width: 100,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      width: 120,
    },
    {
      title: "PnL",
      dataIndex: "pnl",
      key: "pnl",
      width: 120,
      render: (pnl) => (
        <span style={{ color: pnl >= 0 ? "green" : "red" }}>
          ₹{pnl}
        </span>
      ),
    },
  ];

  return (
    <Card title="Groww Holdings">
      <Table
        loading={isLoading}
        columns={columns}
        // dataSource={data?.holdings || []}
        rowKey="id"
        pagination={false}
        scroll={{
          x: 1000, // horizontal scroll
          y: 400,  // vertical scroll
        }}
      />
    </Card>
  );
};

export default GrowwHoldings;













